import styled, { keyframes } from 'styled-components';

export const FormViewWrapper = styled.div`
  height: max-content;
`;

export const FormSectionWrapper = styled.div`
  display: flex;
  height: 100%;
  max-width: 1000px;
  width: 100%;
  margin: auto;
  padding: 0 24px;
  padding-bottom: 75px;

  & > div {
    display: flex;
    flex-direction: column;
    width: 100%;

    & > section:first-of-type {
      align-items: flex-end;

      .vertical-line {
        height: calc(100% - 30px);
      }
    }

    & > section:last-of-type {
      align-items: flex-start;

      .circle {
        top: 50%;
      }

      .vertical-line {
        height: 50%;
      }
    }
  }

  @media (max-width: 600px) {
    padding: 0 12px;
  }
`;

export const SuccessMessage = styled.div`
  max-width: 450px;
  width: 100%;
  margin: auto;
  text-align: center;
  margin-bottom: 75px;

  & > div {
    background-color: #efefef;
    padding-bottom: 32px;
    border-radius: 0 0 10px 10px;
    padding-top: 24px;
  }

  span.success-icon {
    border-radius: 10px 10px 0 0;
    padding: 32px 16px;
    background-color: ${(props) => props.theme.colors.blue}2a;
    width: 100%;
    height: 120px;
    display: block;

    svg {
      padding: 10px;
      height: 100%;
      width: auto;
      background-color: ${(props) => props.theme.colors.blue};
      color: white;
      border-radius: 50%;
      outline: 4px solid ${(props) => props.theme.colors.blue}33;
    }
  }

  p {
    font-size: 20px;
    font-weight: 600;
    color: ${(props) => props.theme.colors.blue};
    margin: 1.5rem auto;
    padding: 1rem;
    margin-top: 0;
  }

  button {
    border-radius: 10px;
    background-color: ${(props) => props.theme.colors.blue};
    border: none;
    outline: none;
    padding: 0.5rem 2rem;
    font-size: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    margin: auto;
    color: white;
    cursor: pointer;

    &:hover {
      opacity: 0.75;
    }

    &:focus-visible {
      outline: 2px solid ${(props) => props.theme.colors.blue};
      outline-offset: 2px;
    }

    svg {
      margin-bottom: -4px;
    }
  }
`;

export const ErrorMessage = styled.div`
  padding: 14px;
  display: flex;
  gap: 2px;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  font-weight: 600;
  font-size: 14px;
  background-color: red;
  color: white;
  position: fixed;
  right: 20px;
  bottom: 20px;
  transform: translateX(calc(100% + 20px));
  transition: all 1s;
  z-index: 99;

  &.active {
    transform: translateX(0px);
  }
`;

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export const SubmitProcessing = styled.div`
  max-width: 1200px;
  width: 100%;
  margin: 0 auto 75px;
  text-align: center;
  min-height: 60vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 24px 24px 0;

  .processing-header {
    border-radius: 10px 10px 0 0;
    padding: 48px 16px;
    background-color: ${(props) => props.theme.colors.blue}2a;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      padding: 10px;
      height: 72px;
      width: 72px;
      background-color: ${(props) => props.theme.colors.blue};
      color: white;
      border-radius: 50%;
      outline: 4px solid ${(props) => props.theme.colors.blue}33;
      animation: ${spin} 1.2s linear infinite;
    }
  }

  .processing-body {
    padding: 24px 32px 32px;
    border-radius: 0 0 10px 10px;
  }

  .processing-title {
    font-size: 24px;
    font-weight: 600;
    color: ${(props) => props.theme.colors.blue};
    margin: 0 0 24px;
  }

  .steps-list {
    display: flex;
    flex-direction: column;
    gap: 20px;
    text-align: left;
    align-items: flex-start;
    width: fit-content;
    margin: 0 auto;
  }

  .step {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 14px;
    transition: opacity 0.3s;

    &.pending {
      opacity: 0.35;
    }

    &.active {
      opacity: 1;
    }

    &.completed {
      opacity: 0.6;
    }
  }

  .step-icon {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    &.pending {
      border: 2px solid #d1d5db;
    }

    &.active {
      border: 3px solid ${(props) => props.theme.colors.blue};
      border-top-color: transparent;
      animation: ${spin} 0.8s linear infinite;
    }

    &.completed {
      background-color: ${(props) => props.theme.colors.blue};
      color: white;

      svg {
        width: 18px;
        height: 18px;
      }
    }
  }

  .step-text {
    font-size: 20px;
    font-weight: 600;
    color: ${(props) => props.theme.colors.authorText};

    .active & {
      color: ${(props) => props.theme.colors.blue};
    }
  }
`;

export const DescriptionSection = styled.div`
  max-width: 1000px;
  width: 100%;
  margin: auto;
  /* padding-left: 38px; */
  padding: 0 24px;
  padding-left: 62px;
  color: ${(props) => props.theme.colors.authorText};

  h3 {
    font-size: 28px;
    margin-bottom: 10px;
  }

  p {
    font-size: 20px;
    margin-top: 0;
    margin-bottom: 46px;
  }
`;
